import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { MenuComponent } from '../../layout/menu/menu.component';
import { RodapeComponent } from '../../layout/rodape/rodape.component';

@Component({
  selector: 'app-private-cloud',
  standalone: true,
  imports: [
    MenuComponent,
    RodapeComponent
  ],
  templateUrl: './private-cloud.component.html',
  styleUrl: './private-cloud.component.css'
})
export class PrivateCloudComponent implements OnInit {
  constructor(private title: Title, private meta: Meta) {}

  ngOnInit() {
    this.title.setTitle('Private Cloud Premium - Fluxodigital');
    this.meta.updateTag({ 
      name: 'description', 
      content: 'Nuvem privada dedicada, escalável e segura para infraestruturas críticas em Angola.' 
    });

    // Open Graph
    this.meta.updateTag({ property: 'og:title', content: 'Private Cloud Premium - Fluxodigital' });
    this.meta.updateTag({ property: 'og:description', content: 'Controle total, isolamento e performance elevada com nossa Private Cloud dedicada.' });
  }
}
